
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-barbie-doll",
      function () {
        return require("private-next-pages/ai-barbie-doll/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-barbie-doll"])
      });
    }
  